import React from "react";

const AreaOfWorkTab = () => {
  return <> Area Of Work </>;
};

export default AreaOfWorkTab;